export default function useHeaderLoggedOutMonarch () {
  const dispatch = ({ type, payload }) => {
    switch (type) {
      default:
        // console.log({ type, payload });
        break;
    }
  };

  return {
    /**
    * The global dispatch that handles all use cases.
    */
    dispatch
  };
}
